import React, { useState, useEffect, useRef } from "react";
import { Button } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import BrushIcon from "@mui/icons-material/Brush";
import BuildIcon from "@mui/icons-material/Build";
import SecurityIcon from "@mui/icons-material/Security";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import EmailIcon from "@mui/icons-material/Email"; // Email icon
import PhoneIcon from "@mui/icons-material/Phone"; // Phone icon
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"; // Question icon
import ContactButtons from "./ContactButtons";
const WHATSAPP_NUMBER = "201003234531"; // Correct format
const handleWhatsAppClick = (whatsappMessage: string) => {
  window.open(
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      whatsappMessage
    )}`,
    "_blank"
  );
};
const ServiceCard: React.FC<{
  title: string;
  description: string;
  buttonText: string;
  Icon: React.ElementType;
  whatsappMessage: string;
}> = ({ title, description, buttonText, Icon, whatsappMessage }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const cardRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsFlipped(entry.isIntersecting);
        });
      },
      { threshold: 0.9 }
    );

    if (cardRef.current) observer.observe(cardRef.current);

    return () => {
      if (cardRef.current) observer.unobserve(cardRef.current);
    };
  }, []);

  return (
    <div
      ref={cardRef}
      className="group w-[500px] h-[500px] p-4 relative cursor-pointer"
      style={{ perspective: "1000px" }}
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
    >
      <div
        className={`relative w-full h-full transition-transform duration-700 ${
          isFlipped ? "rotate-y-180" : ""
        }`}
        style={{
          transformStyle: "preserve-3d",
          transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        {/* Front Side */}
        <div
          className="absolute inset-0 flex flex-col justify-center items-center shadow-lg p-6"
          style={{
            backgroundColor: "#baad87",
            backfaceVisibility: "hidden",
            transform: "rotateY(0deg)",
          }}
        >
          <Icon style={{ fontSize: "3rem", color: "white" }} />
          <h3 className="text-3xl font-bold text-white mt-4">{title}</h3>
        </div>

        {/* Back Side */}
        <div
          className="absolute inset-0 flex flex-col justify-center items-center rounded-lg shadow-lg p-6"
          style={{
            backgroundColor: "#010101",
            color: "white",
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
          }}
        >
          <h3 className="text-3xl font-bold text-[#baad87] mb-4">{title}</h3>
          <p className="text-center text-base leading-relaxed mb-6">
            {description}
          </p>
          <Button
            variant="contained"
            style={{ backgroundColor: "#baad87", color: "#000" }}
            className="font-bold  mt-4"
            onClick={() => handleWhatsAppClick(whatsappMessage)}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

const ServicesSection: React.FC = () => {
  return (
    <section className="  py-12 px-5 mx-0 w-100  min-w-screen  ">
      <div className="text-center mb-10">
        <h2 className="text-4xl font-bold text-white">خدماتنا</h2>
        <div className="w-16 h-1 mx-auto bg-[#baad87] mt-4"></div>
      </div>
      <div className="flex flex-wrap flex-row-reverse gap-2 justify-center items-stretch">
        <div className=" group w-full md:w-1/4 p-4 px-0 h-100 m-4 mx-0 relative cursor-pointer bg-black justify-center items-center flex text-white   ">
          <span className="text-xl font-bold ml-16">خدماتنا</span>
          <span className="border-b-2 w-full border-primary  mt-2  ml-2"></span>
        </div>
        <ServiceCard
          title="التصميمات الداخلية"
          description="نوفر تصاميم داخلية مميزة تجمع بين الجمال والراحة وفقاً لأحدث المعايير والأساليب العالمية."
          buttonText="طلب الخدمة"
          Icon={HomeIcon}
          whatsappMessage="مرحبًا، أود طلب خدمة التصميمات الداخلية."
        />
        <ServiceCard
          title="التشطيبات والديكورات"
          description="فريقنا يعتني بأدق تفاصيل التشطيبات والديكورات لتقديم تجربة فريدة من نوعها تعكس أناقتك."
          buttonText="طلب الخدمة"
          Icon={BrushIcon}
          whatsappMessage="مرحبًا، أود طلب خدمة التشطيبات والديكورات."
        />

        <ServiceCard
          title="الصيانة والتجهيزات"
          description="نقدم خدمات صيانة شاملة لكل ما تحتاجه من تجهيزات بناء بأسلوب محترف لضمان جودة عالية."
          buttonText="طلب الخدمة"
          Icon={BuildIcon}
          whatsappMessage="مرحبًا، أود طلب خدمة الصيانة والتجهيزات."
        />
        <ServiceCard
          title="أنظمة الأمان"
          description="نوفر حلول أمان متكاملة لحماية منشآتك من خلال أنظمة متقدمة للتحكم والسلامة."
          buttonText="طلب الخدمة"
          Icon={SecurityIcon}
          whatsappMessage="مرحبًا، أود طلب خدمة أنظمة الأمان."
        />
        <div
          onClick={() => handleWhatsAppClick("اريد معرفة المزيد")}
          className=" group w-full md:w-1/4 p-4 h-100 m-4 relative cursor-pointer bg-black justify-center items-center flex flex-col text-white   "
        >
          <span className="text-xl font-bold   w-full text-right">
            اتصل بنا!
       
           وحقق 
          حلمك</span>
          <span className="border-b-2 w-full border-primary  mt-2  ml-2">
            <div
              className="bg-primary w-full px-4  py-1  flex justify-between items-center "
              dir="rtl"
            >
              <span>تواصل معنا عبر الواتساب</span>
              <span className="bg-black p-2 ">
                <ArrowBackIosNewOutlined />
              </span>
            </div>
          </span>
        </div>
      </div>
    <ContactButtons />
      {/* <div className="relative flex m-auto w-fit mt-20 items-center justify-center bg-primary mb-52 max-md:hidden">
        <div className="bg-primary px-12 py-4 text-xl font-bold ">عرض مشاريع</div>
        <div className="bg-black rotate-45 w-12 h-12  text-white relative"> <span className="absolute -rotate-45 top-3 left-5" >او</span></div>
        <div className="bg-primary px-12 py-4 text-xl font-bold ">احجز موعد</div>
      </div> */}
    </section>
  );
};

export default ServicesSection;
